import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { genericGetRequest, genericPutRequest, genericDeleteRequest, genericPostRequest } from "../../helpers/sf_backend_helper"
import { call, put, takeEvery } from "redux-saga/effects"
import {
  GET_ADMIN_SF_FILTERS,
  CREATE_ADMIN_SF_FILTER,
  UPDATE_ADMIN_SF_FILTER,
  DELETE_ADMIN_SF_FILTER,
} from "./actionTypes"
import {
  getAdminSfFiltersSuccess,
  getAdminSfFiltersError,
  createAdminSfFilterSuccess,
  createAdminSfFilterError,
  updateAdminSfFilterSuccess,
  updateAdminSfFilterError,
  deleteAdminSfFilterSuccess,
  deleteAdminSfFilterError,
} from "./actions"
import { usStatesOptionsForSf_filters } from "common/data/us_states"
import { STATE_STR } from "helpers/sf_constants"

function* onGetAdminSfFilters() {
  try {
    const user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_sf_filters`;
    const request_payload = {
      body: {},
      headers: {
        "Authorization": user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericGetRequest, URL, request_payload.body, request_payload.headers)
    const newResponse = response.map(el => (el?.name === STATE_STR ? 
      {...el, field_values : JSON.stringify(usStatesOptionsForSf_filters)} : el))
    yield put(getAdminSfFiltersSuccess(newResponse))
  } catch (error) {
    yield put(getAdminSfFiltersError(error))
  }
}

function* onCreateAdminSfFilters(action) {
  try {
    const user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_sf_filters`;
    const request_payload = {
      body: JSON.stringify({
        ...action.payload
      }),
      headers: {
        "Authorization": user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericPostRequest, URL, request_payload)
    yield put(createAdminSfFilterSuccess(response))
  } catch (error) {
    yield put(createAdminSfFilterError(error))
  }
}

function* onUpdateAdminSfFilters(action) {
  try {
    const user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_sf_filters/${action.payload.id}`;
    const request_payload = {
      body: JSON.stringify({
        ...action.payload
      }),
      headers: {
        "Authorization": user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericPutRequest, URL, request_payload)
    yield put(updateAdminSfFilterSuccess(response))
  } catch (error) {
    yield put(updateAdminSfFilterError(error))
  }
}

function* onDeleteAdminSfFilters(action) {
  try {
    const user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_sf_filters/${action.payload}`;
    const request_payload = {
      body: JSON.stringify({
        ...action.payload
      }),
      headers: {
        "Authorization": user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericDeleteRequest, URL, request_payload)
    yield put(deleteAdminSfFilterSuccess(response))
  } catch (error) {
    yield put(deleteAdminSfFilterError(error))
  }
}



function* AdminSfFiltersSaga() {
  yield takeEvery(GET_ADMIN_SF_FILTERS, onGetAdminSfFilters)
  yield takeEvery(CREATE_ADMIN_SF_FILTER, onCreateAdminSfFilters)
  yield takeEvery(UPDATE_ADMIN_SF_FILTER, onUpdateAdminSfFilters)
  yield takeEvery(DELETE_ADMIN_SF_FILTER, onDeleteAdminSfFilters)
}

export default AdminSfFiltersSaga;

